<template>
    <div :class="getClassValue()">
        <label v-if="labelTxt">{{labelTxt}}</label>
        <span v-if="errorVee&&labelTxt" class="glyphicon glyphicon-info-sign text-danger" aria-hidden="true" data-placement="top" :title="errorMsg"></span>
        <slot>
        </slot>
        <span v-if="errorVee&&!labelTxt" class="glyphicon glyphicon-info-sign text-danger" aria-hidden="true" data-placement="top" :title="errorMsg"></span>
    </div>
</template>
<script>
export default {
    props: {
        errorVee: {
            required: true
        },
        hasFormGroup: {
            type: Boolean,
            default: true
        },
        labelTxt: {
            type: String
        },
        errorMsg: {
            type: String,
            default: 'Campo obrigatório'
        }
    },
    methods: {
        getClassValue() {
            let cl = '';
            if ( this.hasFormGroup ) {
                cl += ' form-group';
            }
            if ( this.errorVee ) {
                cl += ' has-error';
            }
            return cl;
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// DivValidation.vue?0b767ea3